import React from "react";
import { ShieldCheckIcon } from "lucide-react";
export function GuaranteeSection() {
  return <section className="bg-cream" data-id="element-81" data-mp="4uqfz2u0sewh">
      <div className="mx-auto max-w-3xl px-5 py-16 text-center md:py-24" data-id="element-82" data-mp="4vrz7ul6w7pa">
        <span className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-sage-light" data-id="element-83" data-mp="9tbemxtmiqit">
          <ShieldCheckIcon className="h-8 w-8 text-sage-deep" aria-hidden="true" data-id="element-84" data-mp="euhbn7ubgzy5" />
        </span>
        <h2 className="mt-6 font-display text-3xl font-semibold leading-tight text-ink md:text-4xl" data-id="element-85" data-mp="jrhhbhn980oq">
          Essayez votre Méga Pack en toute sérénité
        </h2>
        <p className="mt-4 text-sm font-extrabold tracking-wider text-sage-deep md:text-base" data-id="element-86" data-mp="sl480tcludr2">
          GARANTIE SATISFAIT OU REMBOURSÉ — 7 JOURS
        </p>
        <p className="mt-5 leading-relaxed text-ink-soft md:text-lg" data-id="element-87" data-mp="xj5pj9udu50f">
          Nous souhaitons que ce Méga Pack soit une belle ressource pour votre
          famille. Si le contenu ne répond pas à vos attentes, vous pouvez nous
          contacter dans les 7 jours suivant votre achat pour demander un
          remboursement, conformément aux conditions de garantie.
        </p>
      </div>
    </section>;
}